import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast, Toaster } from "sonner";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Charlie.");
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err?.response?.data?.detail) || "Login failed");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6 grain">
      <Toaster position="top-center" />
      <form onSubmit={submit} className="w-full max-w-md border border-ink p-10 bg-cream-2" data-testid="login-form">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-magenta mb-3">Admin Access</p>
        <h1 className="font-serif text-4xl mb-8">Charlie&rsquo;s <span className="italic">Collective</span></h1>
        <div className="space-y-5">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-widest">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-none border-ink mt-2" data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-widest">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-none border-ink mt-2" data-testid="login-password" />
          </div>
        </div>
        <Button type="submit" disabled={submitting} className="w-full mt-8 rounded-none bg-ink hover:bg-magenta text-cream uppercase tracking-widest text-xs py-6" data-testid="login-submit">
          {submitting ? "Entering..." : "Enter"}
        </Button>
      </form>
    </div>
  );
}
